import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";

const validateKey = (key) => {
  if (!key.trim()) return "Alias cannot be empty.";
  if (/[^a-zA-Z0-9_]/.test(key))
    return "Key must be alphanumeric or underscore.";
  return null;
};

const NameAliasesFieldset = ({ value = {}, onChange, onDelete }) => {
  const [[key, val]] = Object.entries(value);
  const [inputKey, setInputKey] = useState(key);
  const [inputValue, setInputValue] = useState(val);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!key || !val) return;
    setInputKey(key);
    setInputValue(val);
  }, [value]);

  useEffect(() => {
    const err = validateKey(inputKey);
    setError(err);
    if (!err) {
      onChange && onChange({ [inputKey]: inputValue });
    } else {
      onChange && onChange(null);
    }
  }, [inputKey, inputValue]);

  return (
    <Row className="align-items-start mb-2">
      <Col>
        <Form.Control
          type="text"
          placeholder="Alias"
          value={inputKey}
          onChange={(e) => setInputKey(e.target.value)}
          isInvalid={!!error}
        />
        {error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </Col>
      <Col>
        <Form.Control
          type="text"
          placeholder="Name"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </Col>
      <Col xs="auto">
        <Button
          className="actionDltBtn border-danger rounded-circle px-2 py-1 h-fit mt-2"
          onClick={onDelete}
        >
          <Trash />
        </Button>
      </Col>
    </Row>
  );
};

export default NameAliasesFieldset;
